export const getContractedCommissionsBlockPropertyPaths = () => {
  return {
    commissionStyle: 'commissionStyle',
    quotedEnrollmentType: 'quotedEnrollmentType',
    quotedCommissionSeries: 'quotedCommissionSeries',
    quotedCommissionLevel: 'quotedCommissionLevel',
    quotedCommissionFYRate: 'quotedCommissionFYRate',
    quotedCommissionRenewalRate: 'quotedCommissionRenewalRate',
    quotedCommissionRate: 'quotedCommissionRate',
  };
};
